import type { Visualization, Settings } from '../types'
import { Event } from '../types'
import { EntityRegistry } from './entity-registry'
import { EventBus } from './event-bus'
import { MapRenderer } from '../renderers/map-renderer'
import { OverlayRenderer } from '../renderers/overlay-renderer'
import { PieRenderer } from '../renderers/pie-renderer'
import { NodeRenderer } from '../renderers/node-renderer'
import { AnimationManager } from './animation-manager'

export class VisualizationManager {
  private readonly element: HTMLElement
  private readonly registry: EntityRegistry = EntityRegistry.getInstance()
  private readonly mapRenderer: MapRenderer
  private overlayRenderer: OverlayRenderer
  private readonly pieRenderer: PieRenderer
  private readonly nodeRenderer: NodeRenderer
  private readonly eventBus: EventBus = EventBus.getInstance()

  constructor (element: HTMLElement) {
    this.element = element
    this.mapRenderer = new MapRenderer(this.element)
    this.pieRenderer = new PieRenderer()
    this.nodeRenderer = new NodeRenderer()
    AnimationManager.getInstance()
  }

  public initialize (settings: Settings): void {
    this.mapRenderer.initialize(settings)
    this.overlayRenderer = new OverlayRenderer(this.mapRenderer.getMap())
    this.mapInitialized = true
  }

  public render (visualization: Visualization): void {
    this.pieRenderer.initialize(this.overlayRenderer, visualization.pies)
    this.nodeRenderer.initialize(this.overlayRenderer)
    this.eventBus.publish(Event.REDRAW)
  }
}
